import React, { useState, useContext } from "react";
import { FormContext } from "../context/FormContext";

const SearchInputTienda = ({ onSearch, tiendasCantidad }) => {
  const [query, setQuery] = useState("");
  const { formData } = useContext(FormContext);


  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      onSearch(query);
    }
  };

  return (
    <form action="#" className="searchstore-form">
      <input
        type="text"
        placeholder="ciudad o comuna"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        onKeyDown={handleKeyDown}
        className="searchstore-input"
      />
      <input
        type="submit"
        value="BUSCAR"
        onClick={(e) => {
          e.preventDefault();
          onSearch(query);
        }}
        className={` searchstore-submit ${formData?.cadena === 'eco' ? "searchstore-submit-eco" : ""}
        ${formData?.cadena === 'gmo' ? "searchstore-submit-gmo" : ""}`}
      />
      <p className="searchstore-qty text-md-start text-center">
        {tiendasCantidad} tienda{tiendasCantidad >= 1 ? "s" : ""} encontrada{tiendasCantidad >= 1 ? "s" : ""}
      </p>
    </form>
  );
};

export default SearchInputTienda;
